var _defs, _path, _path2, _polyline, _polyline2, _line, _line2, _line3, _line4, _line5, _line6, _polygon, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.04 125.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#11ccea;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.96,90.2V10.21s.73-3.3,5.87-5.5,69.35-.73,69.35-.73l-.17,69.35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.15,89.71V9.72s-.73-3.3-5.87-5.5S14.93,3.48,14.93,3.48l.17,69.35"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.17 13.15 3 110.02 76.75 110.75 89.6 121.76 101.34 111.12 135.83 110.75"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.01 82.86 14.01 100.11 85.56 100.11 89.6 106.72 93.63 100.11"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.23,
    y1: 12.92,
    x2: 177.23,
    y2: 82.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.99,
    y1: 27.32,
    x2: 66.6,
    y2: 27.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.99,
    y1: 41.34,
    x2: 51.32,
    y2: 41.34
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.99,
    y1: 54.72,
    x2: 66.6,
    y2: 54.72
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.62,
    y1: 80.93,
    x2: 67.24,
    y2: 80.93
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.37,
    y1: 67.92,
    x2: 51.7,
    y2: 67.92
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "132.52 72.28 155.26 118.75 162.33 110.16 173.69 122.79 183.04 112.69 171.42 102.33 181.02 91.72 132.52 72.28"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.43,
    y1: 26.75,
    x2: 147.05,
    y2: 26.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.43,
    y1: 40.77,
    x2: 131.77,
    y2: 40.77
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseList);
export default __webpack_public_path__ + "static/media/course_list.713c3245b6d0900ab041a512890b0c07.svg";
export { ForwardRef as ReactComponent };